<template>
  <v-btn
    v-if="isMsTeamsPersonalApp"
    icon
    variant="flat"
    @click="toggleSidenav"
  >
    <v-icon>ico-sm-menu</v-icon>
  </v-btn>
</template>
<script lang="ts">
import {
  defineComponent
} from 'vue'
import { useSidenavState } from '@src/ui/SMSidenav/composables/useSidenavState'
import { useOAuthClientId } from '@src/composables/useOAuthClientId'

export default defineComponent({
  name: 'SMSidenavMobileActivatorButton',
  setup() {
    const { toggleSidenav } = useSidenavState()
    const { isMsTeamsPersonalApp } = useOAuthClientId()

    return {
      isMsTeamsPersonalApp,
      toggleSidenav
    }
  }
})
</script>
